module.exports = __webpack_public_path__ + "static/media/13525-empty.1ab01480.gif";